import React from "react";
import "./App.css";
import { ThemeProvider } from "@kui-react/theme";
import Home from "./components/Home";
import Initialize from "./components/Initialize";
import { BrowserRouter as Router, Routes } from "react-router-dom";
 function App() {
  return (
    <ThemeProvider theme="dark">
      <Initialize>
      <Router history={Router}>
          <Routes>
            {/* <Route path={"/"} element={<Home/> } /> */}
          </Routes>
            <Home/> 
        </Router>
        {/* <Home/> */}
      </Initialize>
    </ThemeProvider>
  );
}

export default App;
     